import { defineMessages } from '@/i18n'
import type { Lang } from '@/types/lang'
import { LANG_LABEL } from '@/features/editor/lib/contentLangLabels'
import { EN_LANG_NAME } from '../messages'

export const messages = defineMessages({
  ru: {
    buyCredits: 'Купить кредиты',
    refreshTitle: 'Актуализировать перевод?',
    refreshBody:
      'Устаревшие места будут переведены заново — ручные правки перевода в них будут заменены.',
    cost: (credits: string) => ` Стоимость: ${credits}.`,
    cancel: 'Отмена',
    refresh: 'Актуализировать',
    cancelRunTitle: 'Отменить перевод?',
    cancelRunBody:
      'Уже переведённые уроки и слайды останутся. Работу, которую модель успела выполнить, отменить нельзя — часть токенов будет списана.',
    keepTranslating: 'Продолжить перевод',
    cancelRun: 'Отменить',
    imagesHintNone: 'Картинок с надписями нет — перерисовывать нечего',
    withImages: 'Переводить картинки',
    overwriteTitle: 'Перевести курс заново?',
    overwriteBody:
      'Весь текст второго языка будет заменён, в том числе ваши ручные правки. Отменить нельзя.',
    overwriteConfirm: 'Перевести заново и заменить',
    progress: 'Ход перевода',
    translatingTo: (lang: Lang) => `Переводим на ${LANG_LABEL[lang]} язык`,
    cancelTranslation: 'Отменить перевод',
    hideSummary: 'Скрыть итог',
    translationDone: 'Перевод успешно завершён',
    quoteFailed: 'Смета не загрузилась — объём перевода и цена неизвестны, запуск погашен.',
    refetchQuote: 'Обновить смету',
    quoteLoading: 'Считаем объём перевода и цену…',
    nothingToTranslate: 'Переводить нечего: непереведённых мест сейчас нет.',
    underReview: 'Курс на проверке — перевод станет доступен после решения',
    refreshTranslation: 'Актуализировать перевод',
    translate: 'Перевести',
  },
  en: {
    buyCredits: 'Buy credits',
    refreshTitle: 'Refresh the translation?',
    refreshBody:
      'Outdated parts will be translated again — any manual edits you made to them will be replaced.',
    cost: (credits: string) => ` Cost: ${credits}.`,
    cancel: 'Cancel',
    refresh: 'Refresh',
    cancelRunTitle: 'Cancel the translation?',
    cancelRunBody:
      'Lessons and blocks already translated will stay. Work the model has already done can’t be undone — some credits will be charged.',
    keepTranslating: 'Keep translating',
    cancelRun: 'Cancel',
    imagesHintNone: 'No images with text — nothing to redraw',
    withImages: 'Translate images',
    overwriteTitle: 'Translate the course again?',
    overwriteBody:
      'All second-language text will be replaced, including your manual edits. This can’t be undone.',
    overwriteConfirm: 'Translate again and replace',
    progress: 'Translation progress',
    translatingTo: (lang: Lang) => `Translating into ${EN_LANG_NAME[lang]}`,
    cancelTranslation: 'Cancel translation',
    hideSummary: 'Hide summary',
    translationDone: 'Translation completed',
    quoteFailed:
      'The estimate didn’t load — translation volume and price are unknown, so it can’t start.',
    refetchQuote: 'Refresh estimate',
    quoteLoading: 'Estimating translation volume and price…',
    nothingToTranslate: 'Nothing to translate: there are no untranslated parts right now.',
    underReview:
      'The course is under review — translation will be available once a decision is made',
    refreshTranslation: 'Refresh translation',
    translate: 'Translate',
  },
})
